(() => {
  const nav = document.querySelector('.bd-category-nav');
  if (!nav || nav.dataset.ajaxBound) return;
  nav.dataset.ajaxBound = 'true';
  let controller;
  const icon = nav.querySelector('svg');
  nav.addEventListener('click', async (event) => {
    const link = event.target.closest('a');
    if (!link || !nav.contains(link) || event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href);
    if (url.origin !== location.origin) return;
    const current = document.getElementById('ProductGridContainer');
    const section = nav.closest('[id^="shopify-section-"]');
    if (!current || !section) return;
    event.preventDefault();
    controller?.abort();
    const request = new AbortController();
    controller = request;
    const oldLoader = current.querySelector('bd-collection-load-more');
    oldLoader?._autoLoadObserver?.disconnect();
    current.setAttribute('aria-busy', 'true');
    url.searchParams.set('section_id', section.id.replace('shopify-section-', ''));
    try {
      const response = await fetch(url, { signal: request.signal });
      if (!response.ok) throw new Error('Category unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (request.signal.aborted) return;
      const next = doc.getElementById('ProductGridContainer');
      if (!next) throw new Error('Missing product list');
      next.querySelectorAll('bd-collection-load-more').forEach(loader => {
        loader.dataset.collectionUrl = link.href;
      });
      next.querySelectorAll('.scroll-trigger').forEach(el => {
        el.classList.remove('scroll-trigger--offscreen');
      });
      next.classList.remove('scroll-trigger', 'animate--slide-in');
      current.replaceWith(next);
      nav.querySelectorAll('a').forEach(item => {
        const active = item === link;
        item.classList.toggle('is-active', active);
        item.removeAttribute('aria-current');
        if (active) item.setAttribute('aria-current', 'true');
      });
      if (icon) link.prepend(icon);
      const address = new URL(location.href);
      const handle = new URL(link.href).pathname.split('/').filter(Boolean).pop();
      if (handle === 'alle-produkte-neu') address.searchParams.delete('category');
      else address.searchParams.set('category', handle);
      history.replaceState(history.state, '', address);
      if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(next);
    } catch (error) {
      if (error.name !== 'AbortError') {
        current.removeAttribute('aria-busy');
        oldLoader?.observeNextPage?.();
        window.location.assign(link.href);
      }
    }
  });
  const selected = new URLSearchParams(location.search).get('category');
  if (selected) {
    const initialLink = Array.from(nav.querySelectorAll('a')).find(link =>
      new URL(link.href).pathname.split('/').filter(Boolean).pop() === selected
    );
    initialLink?.click();
  }
})();

